export const ULLY_OPEN_EVENT = 'ully:open';

export const openUlly = (): void => {
  window.dispatchEvent(new CustomEvent(ULLY_OPEN_EVENT));
};
